import CallToAction from './col-call-to-action.jsx';
import PortfolioName from './col-portfolio-name.jsx';
import HeldValue from './col-held-value.jsx';
import Cryptocurrencies from './col-cryptocurrencies.jsx';
import PriceChange24h from './col-price-change-24h.jsx';
import PriceChange7d from './col-price-change-7d.jsx';
import PriceChange30d from './col-price-change-30d.jsx';
import PriceChange60d from './col-price-change-60d.jsx';
import PriceChange1y from './col-price-change-1y.jsx';

// Each individual column object.
const callToAction = new CallToAction();

const portfolioName = new PortfolioName();
const cryptocurrencies = new Cryptocurrencies();
const heldValue = new HeldValue();
const priceChange24h = new PriceChange24h();
const priceChange7d = new PriceChange7d();
const priceChange30d = new PriceChange30d();
const priceChange60d = new PriceChange60d();
const priceChange1y = new PriceChange1y();

/**
 * Returns an ordered array of the columns in the table. Some columns are only
 * shown when including a member's portfolio in the table.
 */
const Columns = function() {
  const columns = [];
  columns.push(callToAction);
  columns.push(portfolioName);
  columns.push(cryptocurrencies);
  columns.push(heldValue);
  columns.push(priceChange24h);
  columns.push(priceChange7d);
  columns.push(priceChange30d);
  columns.push(priceChange60d);
  columns.push(priceChange1y);
  return columns;
};


export default Columns;

